export const DD_MM_YYYY = 'DD/MM/YYYY';



// WEBPACK FOOTER //
// ./src/constants/date.js